// extracted by mini-css-extract-plugin
module.exports = {"button":"Styles_button__xaJ3d","round_variant":"Styles_round_variant__ndBVh"};